import React, { useState } from 'react';
import Input from '../shared/editor-input';
import Confirm from '../shared/confirm';

interface ConfirmAuthProps {
  user: any;
  targetForm: string;
}

const ConfirmAuthButton: React.FC<ConfirmAuthProps> = ({ user, targetForm }: ConfirmAuthProps) => {
  const [dialogVisible, showDialog] = useState(false);
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [verifying, setVerifying] = useState(false);
  const samlAttributes = user.saml_attributes;
  const { email } = user;

  const updatePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleCancel = () => {
    const form = document.getElementById(targetForm);
    if (form && form.tagName === 'FORM') {
      // @ts-ignore
      form.reset();
    }
    setPassword('');
    setErrorMessage('');
    showDialog(false);
  };

  const submitForm = () => {
    const form = document.getElementById(targetForm);
    if (form && form.tagName === 'FORM') {
      // @ts-ignore
      form.submit();
    }
  };

  const handleConfirm = () => {
    setErrorMessage('');
    // @ts-ignore
    const csrfToken = document.head.querySelector('meta[name=csrf-token]')?.content;
    // Make request to auth endpoint
    setVerifying(true);
    fetch('/users/sign_in.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken ?? '' },
      body: JSON.stringify({ user: { email, password } }),
    }).then(
      (res) => {
        setVerifying(false);
        if (res.ok) {
          res.json().then((json) => {
            if (json.email === email) {
              showDialog(false);
              submitForm();
            }
          });
        } else {
          setErrorMessage('Invalid password.');
        }
      },
      (err) => {
        setVerifying(false);
        setErrorMessage('Verification failed.');
      },
    );
  };

  const handleConfirmWithoutPassword = () => {
    showDialog(false);
    submitForm();
  };

  return (
    <div>
      <input
        className="btn btn-affirm outlined"
        form={targetForm}
        type="submit"
        value="Save Changes"
        onClick={(e) => {
          e.preventDefault();
          !samlAttributes
            ? showDialog(true)
            : handleConfirmWithoutPassword();
        }}
      />
      <Confirm
        show={dialogVisible}
        positive="Update my profile"
        negative="Cancel"
        onNegativeClick={handleCancel}
        onPositiveClick={handleConfirm}
      >
        <div style={{ padding: '5px 0' }}>Please re-enter your password to make profile changes:</div>
        <Input name="password" type="password" value={password} placeholder="Password" onChange={updatePassword} />
        {verifying
          && <div style={{ padding: '5px 0' }}>Verifying...</div>}
        {errorMessage.length > 0
          && <div style={{ color: '#ba2a2a', padding: '5px 0' }} className="error">{errorMessage}</div>}
      </Confirm>
    </div>
  );
};

export default ConfirmAuthButton;
